import React, { Component, Fragment } from 'react'

import Label from '../../../components/atoms/Label';
import TextBox from '../../../components/atoms/TextBox';
import Button from '../../../components/atoms/Button';

class StepOtp extends Component {
    _isMounted = false;
    constructor(props){
        super(props)

        this.state = {
            otp1 : '',
            otp2 : '',
            otp3 : '',
            otp4 : '',
            otp5 : '',
            otp6 : '',
            isError : false,
            msg : '',
            minute : 0,
            second : 0
        }

        this.otp1 = React.createRef();
        this.otp2 = React.createRef();
        this.otp3 = React.createRef();
        this.otp4 = React.createRef();
        this.otp5 = React.createRef();
        this.otp6 = React.createRef();
    }


    updateState = ({name, value}) => {
        const val = value.replace(/[^0-9.,]*/g, "");


        if(this._isMounted){
            this.setState({
                [`otp${name}`] : val
            });
        }
    }

    onKeyUpHandle = ({target, key}) => {
        const {name} = target;
        let otpFocus;

        if(key.replace(/[^0-9.,]*/g, "") !== '') {
            otpFocus  = (name === '6') ? name : Number(name)+1;
            this[`otp${otpFocus}`].current.focus();
        }else{
            if(key === 'Delete' || key === 'Backspace'){
                otpFocus  = (name === '1') ? name : Number(name)-1;
                this[`otp${otpFocus}`].current.focus();
            }
        }
    }


    submitOtp = () => {
        const {regState, VerifyNoPonsel, onSubmit} = this.props;
        const {otp1, otp2, otp3, otp4, otp5, otp6} = this.state;
        const data = {
            securityCode : [otp1, otp2, otp3, otp4, otp5, otp6].join(''),
            token : regState.token
        }

        VerifyNoPonsel(data).then((result)=>{
            if(result){
                onSubmit(2)
            }else{

                if(this._isMounted){
                    this.setState({
                        isError : true,
                        msg : this.props.status.error
                    })
                }
            }
        })
    }

    resendOtp = () => {
        const {regState, ResendOtp} = this.props;
        ResendOtp(regState.token).then(res => {
            if(res){
                this.startTimer();
            }else{
                if(this._isMounted){
                    this.setState({
                        isError : true,
                        msg : this.props.status.error
                    })
                }
            }
        })
    }
    
    
    updateTimer = () => {
        const {second, minute} = this.state;

        if(this._isMounted){
            if(second !== 0 || minute !== 0){
                if(second === 0){
                    this.setState({
                        second : 59,
                        minute : minute - 1
                    })
                }else{
                    this.setState({second : second-1})
                }
            }else{
                this.stopTimer();
                this.setState({timerActive : ''});        
            }
        }
    }

    stopTimer = () => {
        clearInterval(this.timer);
        if(this._isMounted){
            this.setState({minute : 0, second : 0});
        }
    }
    
    startTimer = (type) => {
        (this.timer) && this.stopTimer();
        
        if(this._isMounted){
            this.setState({minute : 1, second : 0, timerActive : type});
        }
        this.timer = setInterval(this.updateTimer, 1000);
    }
    
    componentDidMount = () => {
        this._isMounted = true;

        this.otp1.current.focus();
        this.startTimer();
    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    render() {
        const {otp1, otp2, otp3, otp4, otp5, otp6, isError, msg, second, minute} = this.state;

        return (
            <Fragment>
                <div className='form-regisiter form-otp d-flex justify-content-center align-items-center'>
                    <div className='form-group mt-2 text-center'>
                        <Label type='label' for='noponsel' value='Masukan Kode OTP' className='label-kc-sb require' />
                        <div className='d-flex justify-content-center mt-2'>
                            <TextBox name='1' opts={{maxLength : 1, ref : this.otp1, onKeyUp : (e) => this.onKeyUpHandle(e)}} value={otp1} className={otp1 !== '' ? 'otp-done' : ''} onChange={(e) => this.updateState(e.target)} type='text' />
                            <TextBox name='2' opts={{maxLength : 1, ref : this.otp2, onKeyUp : (e) => this.onKeyUpHandle(e)}} value={otp2} className={otp2 !== '' ? 'otp-done' : ''} onChange={(e) => this.updateState(e.target)} type='text' />
                            <TextBox name='3' opts={{maxLength : 1, ref : this.otp3, onKeyUp : (e) => this.onKeyUpHandle(e)}} value={otp3} className={otp3 !== '' ? 'otp-done' : ''} onChange={(e) => this.updateState(e.target)} type='text' />
                            <TextBox name='4' opts={{maxLength : 1, ref : this.otp4, onKeyUp : (e) => this.onKeyUpHandle(e)}} value={otp4} className={otp4 !== '' ? 'otp-done' : ''} onChange={(e) => this.updateState(e.target)} type='text' />
                            <TextBox name='5' opts={{maxLength : 1, ref : this.otp5, onKeyUp : (e) => this.onKeyUpHandle(e)}} value={otp5} className={otp5 !== '' ? 'otp-done' : ''} onChange={(e) => this.updateState(e.target)} type='text' />
                            <TextBox name='6' opts={{maxLength : 1, ref : this.otp6, onKeyUp : (e) => this.onKeyUpHandle(e)}} value={otp6} className={otp6 !== '' ? 'otp-done' : ''} onChange={(e) => this.updateState(e.target)} type='text' />
                        </div>

                        <Label type='note' className='red mt-2' value={msg} />
                    </div>
                </div>

                <Button type='submit' title='KIRIM KODE OTP' isDesibled = {isError} isDisabled={
                    (otp1 === '' || otp2 === '' || otp3 === '' || otp4 === '' || otp5 === '' || otp6 === '') ? true : false
                } loading={this.props.status.loading} onClick={this.submitOtp} color='blue' width='block'/>

                <label className='label-kc blue mt-3 d-block'>
                    Kirim Ulang OTP <b>{(second !== 0 || minute !== 0) ? ('0' + minute).slice(-2)+':'+('0' + second).slice(-2) : <span className='link' onClick={()=>{ this.resendOtp(); }}>Klik di Sini</span> }</b>
                </label>
            </Fragment>
        )
    }
}

export default StepOtp;